<template>
  <div>
    <el-dialog title="账号申诉" :visible.sync="dialogVisible" width="40%">
      <div style="width: 90%; margin: 0px auto">
        <el-form
          ref="applyFormRef"
          label-position="right"
          label-width="80px"
          :model="applyForm"
          size="medium"
        >
          <el-form-item label="手机号" prop="phone">
            <div style="display: flex">
              <el-input
                v-model="applyForm.phone"
                style="flex: 1; margin-right: 5px"
              ></el-input>
              <el-button
                type="primary"
                v-show="authCodeFlag"
                @click="getAuthCode"
              >
                获取验证码
              </el-button>
              <div class="missTime" v-show="!authCodeFlag">{{ missTime }}s</div>
            </div>
          </el-form-item>
          <el-form-item label="验证码" prop="authCode">
            <el-input v-model="applyForm.authCode"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input v-model="applyForm.password"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogVisible = false">
          取 消
        </el-button>
        <el-button size="medium" type="primary" @click="submit">
          提 交
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAuthCode, resetPwd } from "@/api/register";

export default {
  name: "ApplyPage",
  data() {
    return {
      dialogVisible: false,
      // 申诉 表
      applyForm: {
        authCode: "",
        phone: "",
        password: "",
      },
      //
      applyCheck: {
        showIdCardErrInfo: false,
      },
      //
      applyFormRules: {},
      authCodeFlag: true,
      // 时间
      missTime: 120,
    };
  },
  methods: {
    // 显示
    showDialog() {
      this.dialogVisible = true;
    },
    // 获取验证完
    getAuthCode() {
      let _that = this;
      if (!_that.applyForm.phone) {
        _that.$message.error("请输入手机号码！");
        return;
      }
      getAuthCode(_that.applyForm.phone).then((res) => {
        console.log(res);
        if (res.data.success) {
          _that.authCodeFlag = false;
          _that.countDown();
        }
      });
    },
    // 倒计时
    countDown() {
      let _that = this;
      _that.timer = setInterval(function () {
        if (_that.missTime == 0) {
          _that.authCodeFlag = true;
          clearInterval(timer);
          _that.missTime = 120;
        } else {
          _that.missTime--;
        }
      }, 1000);
    },
    //
    submit() {
      let _that = this;
      resetPwd(_that.applyForm).then((res) => {
        // console.log(res);
        if (res.data.success) {
          _that.$message.success(res.data.msg);
          _that.dialogVisible = false;
        } else {
          _that.$message.error(res.data.msg);
        }
      });
    },
  },
  watch: {
    // 监听对话框关闭事件
    dialogVisible(newVal, oldVal) {
      // console.log(newVal);
      if (!newVal) {
        this.missTime = 120;
        // this.$refs["applyFormRef"].resetField();
        this.applyForm = {
          authCode: "",
          phone: "",
          password: "",
        };
      }
    },
  },
};
</script>

<style scoped>
.missTime {
  width: 80px;
  height: 100%;
  text-align: center;
  color: #fff;
  background-color: #ccc;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/view/login/components/ApplyPage.vue